import axiosInstanceNode from "@/api/axiosInstanceNode";

const data = (res) => res.data;

export const getVoiceSetup = () => axiosInstanceNode.get("/voice/setup").then(data);

export const requestVoiceApproval = () =>
  axiosInstanceNode.post("/voice/setup/approval-request").then(data);

export const provisionVoiceCalling = () =>
  axiosInstanceNode.post("/voice/setup/provision").then(data);

export const saveVoiceBusinessDetails = (payload) =>
  axiosInstanceNode.put("/voice/setup/business", payload).then(data);

export const acceptVoiceAgreement = (version) =>
  axiosInstanceNode.post("/voice/setup/agreement", { accepted: true, version }).then(data);

export const searchVoiceNumbers = (areaCode) =>
  axiosInstanceNode
    .get("/voice/numbers/search", { params: { area_code: areaCode || undefined } })
    .then(data);

export const buyVoiceNumber = (number) =>
  axiosInstanceNode.post("/voice/numbers", { number }).then(data);

export const setDefaultVoiceNumber = (number) =>
  axiosInstanceNode.patch(`/voice/numbers/${encodeURIComponent(number)}/default`).then(data);

export const releaseVoiceNumber = (number) =>
  axiosInstanceNode.delete(`/voice/numbers/${encodeURIComponent(number)}`).then(data);

export const getVoiceToken = () => axiosInstanceNode.post("/voice/token").then(data);

export const prepareVoiceCall = (relationContactId) =>
  axiosInstanceNode
    .post("/voice/calls/prepare", { relation_contact_id: relationContactId })
    .then(data);

export const markDoNotCall = (callId) =>
  axiosInstanceNode.post("/voice/suppressions", { call_id: callId }).then(data);
